import { AiColEnrichmentModalSteps } from '../../enums';

import ChooseOptionStep from './enrich-options-step/enrich-options-step';
import TemplateListStep from './enrich-templates-list-step';
import TemplateDetailStep from './enrich-template-detail-step';
import CustomPromptStep from './enrich-custom-prompt-step/enrich-custom-prompt-step';
import ExistingColumnStep from './enrich-existing-column-step/enrich-existing-column-step';

const AI_COLUMNS_STEP_COMPONENT_MAP: Record<AiColEnrichmentModalSteps, React.ComponentType<any>> = {
  [AiColEnrichmentModalSteps.ENRICH_OPTION]: ChooseOptionStep,
  [AiColEnrichmentModalSteps.TEMPLATE_LIST]: TemplateListStep,
  [AiColEnrichmentModalSteps.TEMPLATE_DETAIL]: TemplateDetailStep,
  [AiColEnrichmentModalSteps.CUSTOM_PROMPT]: CustomPromptStep,
  [AiColEnrichmentModalSteps.EXISTING_COLUMN]: ExistingColumnStep,
};

export default AI_COLUMNS_STEP_COMPONENT_MAP;
